import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { createLead } from "../../../../common/services/leads.api";
import FormCreateLead from "../forms/FormCreateLead";
import { ILead } from "../../../../types/lead.type";

type Props = {
  onClose?: () => void;
  onSave: (leadId: string) => void;
  openConfirmEdit: (leadData: ILead) => void;
  roles: string[] | undefined;
};

export default function ModalCreateLead(props: Props) {
  const { notifySuccess, notifyError, notifyInfo } = useToastContext();

  const handleCloseModal = () => {
    props.onClose && props.onClose();
  };

  async function handleSubmit(dataToSave) {
    try {
      const result = await createLead(dataToSave);

      const { data } = result;

      if (data.exist) {
        if (props.roles && props.roles.includes("ambassador")) {
          handleCloseModal();
          notifyInfo("Já está cadastrado");
          return;
        }
        props.openConfirmEdit(data);
        return;
      }

      if (!result) {
        throw new Error("Erro ao tentar salvar lead, tente novamente");
      }
      props.onSave((data as { _id: string })?._id);
      notifySuccess(`Lead "${(data as { name: string }).name}" cadastrado!`);
    } catch (err) {
      console.log(err);
      notifyError((err as Error).message as string);
    }
  }

  return (
    <Modal
      className="relative dark:text-black text-black"
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="dark:text-black">
        <h2 className="text-black">Novo Cliente</h2>
      </Modal.Header>
      <Modal.Body>
        <FormCreateLead onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  );
}
